import styled from '@emotion/styled';

import { CircularProgress } from '@material-ui/core';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const Container = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-end;

  margin-bottom: ${spacing.xxLarge};
`;

export const CSVButton = styled.div`
  margin-right: ${spacing.small};
`;

export const Loader = styled(CircularProgress)`
  color: ${COLORS.white};
`;

// 69 = minimum possible width of export button
export const LoaderContainer = styled.div`
  min-width: 69px;
`;
